import { Navigation } from "@/components/public/layout/Navigation"
import { Footer } from "@/components/public/layout/Footer"
import FloatingMenu from "@/components/public/FloatingMenu"
import BrinIseasJoinConference from "@/components/public/BrinIseasJoinConference";

export default function BrinIseasJoinConferencePage() {
    return (
        <div className="min-h-screen bg-background dark:bg-gray-900">
            <Navigation />
            <BrinIseasJoinConference />
            <Footer />
            <FloatingMenu />
        </div>
    )
}
